import cx from 'classnames'

import { type GalleryCarouselItem } from '@lib/gallery'

import Photo from '@components/photo'

interface GalleryCarouselThumbnailProps {
  item: GalleryCarouselItem
  isSelected?: boolean
  onClick?: () => void
}

const GalleryCarouselThumbnail = ({
  item,
  isSelected,
  onClick,
}: GalleryCarouselThumbnailProps) => {
  switch (item.type) {
    case 'image': {
      return (
        <button
          onClick={onClick}
          className={cx(
            'carousel-thumbnail hover:opacity-60 duration-300 transition-opacity',
            {
              'opacity-60': isSelected,
            },
          )}
        >
          <Photo
            image={item.image}
            fill
            sizes="96px"
            className="relative w-14 h-14 xs:h-20 xs:w-20 md:w-24 md:h-24"
            imageClassName="object-cover"
          />
        </button>
      )
    }

    case '3d-preview': {
      return (
        <button
          onClick={onClick}
          className={cx(
            'carousel-thumbnail hover:opacity-60 duration-300 transition-opacity',
            {
              'opacity-60': isSelected,
            },
          )}
        >
          <div className="flex justify-center items-center w-14 h-14 xs:h-20 xs:w-20 md:w-24 md:h-24 bg-gray-100">
            {/* TODO: Fix thumbnail look. */}
            <span>3D</span>
          </div>
        </button>
      )
    }
  }

  return null
}

export default GalleryCarouselThumbnail
